/* @jsx h */
import { api } from "@app/data/index";
import { Device } from "@lemmonhq/types";
import { Loading } from "@app/vue/components/index";
import { setTitle } from "@lemmonhq/orders";
import { defineComponent, onMounted, onUnmounted, ref, h } from "vue";
import { RouterView, useRoute, useRouter } from "vue-router";
import { DeviceMenu } from "./DeviceMenu";
import { NoDevices } from "./NoDevices";

export { PaymentTerminalDetails } from "./PaymentTerminalDetails";
export { PrinterDetails } from "./PrinterDetails";
export { PrinterSetupWizard } from "./PrinterSetupWizard";

export const DevicesPage = defineComponent({
  name: "DevicesPage",
  props: ["children"],
  setup(props) {
    const devices = ref<Device[]>([]);
    const loading = ref(true);
    const router = useRouter();
    const route = useRoute();

    let unMounted: boolean;

    onUnmounted(() => {
      unMounted = true;
    });

    onMounted(() => {
      setTitle("Devices");
    });

    onMounted(async () => {
      let cancelled = false;
      const fetchDevices = async () => {
        try {
          const [printers, terminals] = await Promise.all([
            api.getPrinters(),
            api.getPaymentTerminals(),
          ]);

          const allDevices = [...printers, ...terminals];
          if (cancelled) return;
          devices.value = allDevices;

          // Navigate to first device if available
          if (allDevices.length > 0 && !route.params.id && !unMounted) {
            const firstDevice = allDevices[0];
            router.replace(
              `/app/devices/${firstDevice.type}/${firstDevice.device.id}`,
            );
          }
        } catch (error) {
          console.error("Failed to fetch devices:", error);
        } finally {
          loading.value = false;
        }
      };

      fetchDevices();
      return () => {
        cancelled = true;
      };
    });

    return () => {
      if (loading.value) {
        return (
          <div class="w-full h-full flex flex-1 justify-center items-center">
            <Loading />
          </div>
        );
      }

      if (!loading.value && devices.value.length === 0) {
        return <NoDevices />;
      }

      return (
        <div class="flex h-full p-0 lg:p-4 xl:p-4 flex-1 z-[0]">
          <div class="overflow-x-auto flex flex-col md:flex-row flex-1 h-full border  rounded-md">
            <DeviceMenu devices={devices.value} />
            <div class="flex-1 flex">
              <RouterView {...{ devices }} />
            </div>
          </div>
        </div>
      );
    };
  },
});
